import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class ExecutiveMemoService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  getExecutiveMemosList(pageNo: number, pageSize: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/execmemo?pageNo=" + pageNo + "&pageSize=" + pageSize).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getExecutiveMemosById(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "management/execmemo/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  saveExecutiveMemos(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.post(this.url + "management/execmemo", data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  updateExecutiveMemos(id: number, data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.put(this.url + "management/execmemo/" + id, data).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  deleteExecutiveMemos(id: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.delete(this.url + "management/execmemo/" + id).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getMemoDownloadURL(): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "management/execmemo/download?token=" + authToken;
  }

  downloadMemos(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "management/execmemo/download").subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }



}